<input pInputText type="text" [(ngModel)]="nombreEtiqueta" style="width: 100%;"
    [placeholder]="nombreEtiqueta">
